const capitalise = (text, opts: { force?: boolean } = {}) => {
  if (typeof text !== "string") return text ? text.toString() : "";

  // This is here to force what we think of as capitalisation on text
  // that is uppercased or mixed cased
  if (opts.force) {
    text = text.toLowerCase();
  }

  return text.replace(/(?:^|\s|["'([{])+\S/, (match) => match.toUpperCase());
};

export default capitalise;
